import toastService from '@/services/toast/service';
import { isSilentFailure } from './template-admin';

/**
 * For a catch in the Templates pages: toasts the fallback ("Couldn't <verb> <object>", the failed action) when
 * nothing else told the person what went wrong. The api client already toasts a server message, so those errors
 * are left alone.
 */
export function toastIfSilent(error: unknown, fallback: string): void {
  if (isSilentFailure(error)) toastService.error(fallback);
}
